export default class Captcha {
    constructor($field, $form) {
        this.$field = $field;
        this.$form = $form;
        this.submited =  false;

        this.checkCaptcha = this.checkCaptcha.bind(this);

        this.$form.addEventListener('submit', this.checkCaptcha);
    }

    checkCaptcha(e) {
        e.preventDefault();

        if (self.submitted) {
            return false;
        }

        grecaptcha.ready(() => {
            grecaptcha.execute(this.$field.dataset.key, {action: 'homepage'}).then((token) => {
                this.$field.value = token;

                this.submitted = true;
                this.$form.submit();
            });
        });
    }
}